module.exports = __webpack_public_path__ + "static/media/matilde-train.f1f52ed3.png";